import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from '@mui/material';
import useAlias from '@src/hooks/useAlias';
import React from 'react';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemType: 'field' | 'setting';
  itemName?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  itemType,
  itemName,
}) => {
  const alias = useAlias();

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ p: 2, pb: 0 }}>
        <Typography variant='h6' id='alert-dialog-title'>
          {alias('Confirm Delete {itemType}', {
            itemType:
              itemType === 'setting' ? alias('Setting') : alias('Field'),
          })}
        </Typography>
      </Box>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {itemType === 'setting'
            ? alias(
                'Are you sure you want to delete the setting "{itemName}"? This will also delete all fields within this setting.',
                { itemName: itemName || '' },
              )
            : alias('Are you sure you want to delete the field "{itemName}"?', {
                itemName: itemName || '',
              })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          <FormattedAlias id='Cancel' />
        </Button>
        <Button onClick={onConfirm} color='error' autoFocus>
          <FormattedAlias id='Delete' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
